
import React, { useEffect, useMemo, useState } from "react";
import {Box,Button,Chip,CircularProgress,Container,
  CssBaseline,Grid,IconButton,Paper,Table,TableBody,TableCell,TableContainer,TablePagination,TableHead,TableRow,ToggleButton,ToggleButtonGroup,
  Typography,useTheme,useMediaQuery,Modal, Card, CardContent,  Stack, Fade, Backdrop,
  Alert, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@mui/material";
import {
  ArrowBack      as ArrowBackIcon,
  Refresh        as RefreshIcon,
  Close          as CloseIcon,
  CalendarMonth  as CalendarIcon,
  AccessTime     as TimeIcon,
  Person         as PersonIcon,
  CancelOutlined as CancelIcon,
  WarningAmberRounded as WarnIcon,
  LocationOn     as LocationIcon,
  LocalHospital  as NursingIcon,
  FitnessCenter  as PhysioIcon,
  MedicalServices as MedicalIcon,
  Phone          as PhoneIcon,
  History        as HistoryIcon,
  CurrencyRupee  as CurrencyRupeeIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import  bg2 from "../../Logos/med_background2.png"


import { useNavigate } from "react-router-dom";
import { fetchUserFromRedis } from "../../HomePage/AuthonticationScreens/Register";
import axios from 'axios'


const FONT_DISPLAY = "'Sora', 'Segoe UI', sans-serif";
const FONT_BODY = "'Inter', 'Segoe UI', sans-serif";

const INK = "#0E2A2E";
const INK_MUTED = "#5B7278";
const BORDER = "#E1E8E9";
const SURFACE = "#FFFFFF";
const PAGE_BG = "#F4F7F7";
const TEAL = "#0B6E76";
const TEAL_DARK = "#083F44";
const TEAL_SOFT = "#E5F2F1";
const CORAL = "#B8654A";
const CORAL_SOFT = "#FBEAE6";
const AMBER = "#B45309";
const AMBER_SOFT = "#FEF3C7";
const GREEN = "#15803D";
const GREEN_SOFT = "#DCFCE7";
const RED = "#DC2626";
const RED_SOFT = "#FDEBEB";
const BLUE = "#2563EB";
const BLUE_SOFT = "#E7EFFE";
const SLATE = "#64748B";
const SLATE_SOFT = "#F1F5F9";

const BOOKING_TYPES = [
  { key: "all", label: "All bookings" },
  { key: "medicine", label: "Medicine orders" },
  { key: "diagnostic", label: "Diagnostic orders" },
  { key: "nursing & Physiotherapy", label: "Nursing & Physiotherapy" },
];
const API = process.env.REACT_APP_API_BASE_URL;


const getUserId = () =>
  sessionStorage.getItem("userId") || localStorage.getItem("userId") || null;

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
const formatTime = (dateString) => {
    if (!dateString) return "N/A";
  
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date";
  
      // Add 5 hours 30 minutes (IST offset)
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);
  
      return date.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
      });
    } catch (error) {
      console.error("Error formatting time:", error);
      return "N/A";
    }
  };
  

// Format Date in IST (e.g., "Dec 23, 2025")
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    
    // ✅ Add timeZone: 'Asia/Kolkata' to ensure IST
    return date.toLocaleDateString('en-IN', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Asia/Kolkata'
    });
  } catch (error) {
    return "N/A";
  }
};
const CAT_META = {
  nursing: {
    icon:     <NursingIcon />,
    gradient: `linear-gradient(135deg, ${TEAL}, ${TEAL_DARK})`,
    accent:   TEAL,
    lightBg:  TEAL_SOFT,
    emoji:    "🏥",
  },
  physiotherapy: {
    icon:     <PhysioIcon />,
    gradient: `linear-gradient(135deg, ${CORAL}, #8B3E2F)`,
    accent:   CORAL,
    lightBg:  CORAL_SOFT,
    emoji:    "🦾",
  },
};

const StatusDot = ({ label, color, bg, border }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      bgcolor: bg,
      border: `1px solid ${border}`,
      color,
      borderRadius: "6px",
      px: "8px",
      py: "3px",
      fontFamily: FONT_BODY,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.4,
      whiteSpace: "nowrap",
    }}
  >
    <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: color, flexShrink: 0 }} />
    {label}
  </Box>
);

const StatusChip = ({ value }) => {
  const c = STATUS_CFG[value] || { bg: SLATE_SOFT, text: SLATE, border: "#E2E8F0", label: value };
  return <StatusDot label={c.label} color={c.text} bg={c.bg} border={c.border} />;
};
const STATUS_CFG = {
  pending:   { bg: AMBER_SOFT, text: AMBER, border: "#FCD34D", label: "Pending review" },
  confirmed: { bg: BLUE_SOFT,  text: BLUE,  border: "#93C5FD", label: "Confirmed"      },
  completed: { bg: GREEN_SOFT, text: GREEN, border: "#86EFAC", label: "Completed"      },
  cancelled: { bg: RED_SOFT,   text: RED,   border: "#FCA5A5", label: "Cancelled"      },
};
const InfoItem = ({ label, value }) => (
  <Box sx={{ background: "#F8FAFB", borderRadius: "10px", p: "10px 13px", border: `1px solid ${BORDER}` }}>
    <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11, fontWeight: 600, color: INK_MUTED, mb: 0.4 }}>
      {label}
    </Typography>
    <Typography sx={{ fontFamily: FONT_BODY, fontSize: 13.5, fontWeight: 600, color: INK, wordBreak: "break-word" }}>
      {value || "—"}
    </Typography>
  </Box>
);

// ─── Cancel confirmation dialog ───────────────────────────────────────────────
const CancelDialog = ({ booking, onConfirm, onClose, loading }) => (
  <Dialog open onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "14px", p: 1 } }}>
    <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
      <Box sx={{
        width: 56, height: 56, borderRadius: "50%", bgcolor: AMBER_SOFT,
        border: "1px solid #FCD34D", display: "flex", alignItems: "center",
        justifyContent: "center", mx: "auto", mb: 2,
      }}>
        <WarnIcon sx={{ fontSize: 28, color: AMBER }} />
      </Box>
      <Typography sx={{ fontFamily: FONT_DISPLAY, fontSize: 18, fontWeight: 700, mb: 1, color: INK }}>
        Cancel this booking?
      </Typography>
      <Typography sx={{ fontFamily: FONT_BODY, fontSize: 14, color: INK_MUTED, mb: 2, lineHeight: 1.6 }}>
        This can't be undone. The patient will need to book again if this was scheduled by mistake.
      </Typography>
      <Box sx={{ bgcolor: SLATE_SOFT, border: `1px solid ${BORDER}`, borderRadius: "8px", py: 1, px: 2, fontFamily: "monospace", fontSize: 13.5, fontWeight: 700, color: TEAL, display: "inline-block" }}>
        {booking.booking_ref}
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
      <Button fullWidth variant="outlined" onClick={onClose}
        sx={{ borderColor: BORDER, color: INK_MUTED, py: 1.2, borderRadius: "10px", textTransform: "none", fontFamily: FONT_BODY, fontWeight: 600 }}>
        Keep booking
      </Button>
      <Button fullWidth variant="contained" onClick={() => onConfirm(booking._id)}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <CancelIcon />}
        sx={{ bgcolor: RED, py: 1.2, borderRadius: "10px", fontWeight: 700, textTransform: "none", fontFamily: FONT_BODY, "&:hover": { bgcolor: "#B91C1C" } }}>
        {loading ? "Cancelling…" : "Yes, cancel it"}
      </Button>
    </DialogActions>
  </Dialog>
);


const getStatusChipProps = (status) => {
  const normalized = String(status || "").toLowerCase();
  if (["delivered", "paid", "success", "completed"].includes(normalized)) {
    return { color: GREEN, bg: GREEN_SOFT, border: "#86EFAC", label: status };
  }
  if (["cancelled", "failed", "declined", "rejected"].includes(normalized)) {
    return { color: RED, bg: RED_SOFT, border: "#FCA5A5", label: status };
  }
  if (["new"].includes(normalized)) {
    return { color: BLUE, bg: BLUE_SOFT, border: "#93C5FD", label: status };
  }
  return { color: AMBER, bg: AMBER_SOFT, border: "#FCD34D", label: status };
};
const getBookingTypeChipStyles = (type) => {
  const normalized = String(type || "").toLowerCase();

  if (normalized === "medicine") {
    return { bgcolor: BLUE_SOFT, color: "#0369A1", border: "#BAE6FD" };
  }

  if (normalized === "diagnostic") {
    return { bgcolor: "#F5E8FF", color: "#7C3AED", border: "#E9D5FF" };
  }

  if (normalized.includes("nursing") || normalized.includes("physio")) {
    return { bgcolor: GREEN_SOFT, color: "#15803D", border: "#BBF7D0" };
  }

  return { bgcolor: SLATE_SOFT, color: SLATE, border: "#E2E8F0" };
};
const getPaymentStatusChipProps = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (["paid", "success", "completed", "succeeded", "successful", "settled"].includes(normalized)) {
    return { label: status || "Paid", bg: GREEN_SOFT, color: GREEN, border: "#86EFAC" };
  }

  if (["pending", "processing", "initiated", "awaiting", "unpaid", "not paid"].includes(normalized)) {
    return { label: status || "Pending", bg: AMBER_SOFT, color: AMBER, border: "#FCD34D" };
  }

  if (["partial", "partially paid", "partially_paid","pay to agent"].includes(normalized)) {
    return { label: status || "Partial", bg: BLUE_SOFT, color: BLUE, border: "#93C5FD" };
  }

  if (["failed", "cancelled", "declined", "rejected", "expired", "error"].includes(normalized)) {
    return { label: status || "Failed", bg: RED_SOFT, color: RED, border: "#FCA5A5" };
  }

  return { label: status || "Unknown", bg: SLATE_SOFT, color: SLATE, border: "#CBD5E1" };
};

const normalizeBooking = (item, type) => {
  if (!item) return null;

  const serviceName =
    item.service_name || item.diagnostic_tests ||
    item.order_type ||
    item.category ||
    (type === "medicine"
      ? "Medicine Order"
      : type === "diagnostic"
      ? "Diagnostic Order"
      : "Nursing & Physiotherapy");

  const patientName =
    item.patient_name ||
    item.customer_name ||
    item.patient ||
    item.patient_details?.name ||
    item.patient_details?.full_name ||
    item.guest_name ||
    "Unknown";

  return {
    id: item.order_id || item.booking_id || item.booking_ref || item.id || item._id,
    booking_type: type,
    service_name: serviceName,
    patient_name: patientName,
    status: item.status || item.order_status || item.delivery_status || "unknown",
    date:
      item.delivery_date ||
      item.start_date ||
      item.scheduled_date ||
      item.date ||
      item.booking_date ||
      item.scheduled_at ||
      item.created_at ||
      "",
    end_date:item.end_date || '',
    amount:
      item.total_amount ||
      item.amount ||
      item.order_total ||
      item.order_pricing?.totalSellingRevenue ||
      item.payment?.amount ||
      item.amount_paid ||
      item.amount_due ||
      0,
    payment_status: item.payment?.status || item.payment_status || "unknown",
    payment_method:
      item.payment?.method ||
      item.payment_method ||
      item.payment?.type ||
      item.payment?.transaction_history?.[0]?.method ||
      "",
    order_type: item.order_type || serviceName,
    item_count: Array.isArray(item.items)
      ? item.items.length
      : Array.isArray(item.sessions)
      ? item.sessions.length
      : 0,
    patient_phone:
      item.patient_details?.phone || item.patient_phone || item.address?.phone || item.delivery_address?.phone || "",
    raw: item,
  };
};

// ─── Booking Detail Modal ─────────────────────────────────────────────────────

const BookingDetailModal = ({ booking, onClose, onCancelRequest }) => {
  const muiTheme   = useTheme();
  const fullScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const [docViewUrl, setDocViewUrl] = useState("");
  if (!booking) return null;

  const meta      = CAT_META[booking.category] || CAT_META.nursing;
  const canCancel = ["pending", "confirmed"].includes(booking.status);
  const handleInvoiceDownload=async(order_id)=>{
    try {
          const token = sessionStorage.getItem("token");

          const response = await axios.get(
            `${process.env.REACT_APP_API_INVOICE}/nursing-invoice/download/${order_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const download_url=response.data.download_url
          window.open(download_url, "_blank");
        } catch (error) {
          console.error("Invoice download failed:", error);
        }
}

  return (
    <>
    <Modal open onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300, sx: { backdropFilter: "blur(5px)", backgroundColor: "rgba(9,25,28,0.55)" } }}>
      <Fade in>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)",
          width: fullScreen ? "95vw" : 520,
          maxHeight: "90vh", overflowY: "auto",
          bgcolor: SURFACE, borderRadius: "16px",
          boxShadow: "0 24px 64px rgba(9,25,28,0.28)",
        }}>
          {/* Gradient header */}
          <Box sx={{ background: meta.gradient, p: "24px 22px 18px", position: "relative", overflow: "hidden" }}>
            <Box sx={{ position: "absolute", top: -40, right: -40, width: 150, height: 150, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
            <Box sx={{ position: "absolute", bottom: -30, left: -20, width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
            <IconButton onClick={onClose} size="small" sx={{
              position: "absolute", top: 12, right: 12, zIndex: 2,
              bgcolor: "rgba(255,255,255,0.18)", color: "#fff",
              "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
            }}>
              <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Typography sx={{ fontSize: 30, lineHeight: 1, mb: 0.75 }}>{meta.emoji}</Typography>
              <Typography sx={{ fontFamily: FONT_DISPLAY, fontWeight: 700, color: "#fff", fontSize: { xs: 16, sm: 18 }, mb: 0.6 }}>
                {booking.service_name}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
                <Box sx={{ display: "inline-block", bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 12, fontWeight: 700, px: 1.4, py: 0.3, borderRadius: "6px", fontFamily: "monospace" }}>
                  {booking.booking_ref}
                </Box>
                <Box sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: 11, fontWeight: 600, px: 1.2, py: 0.3, borderRadius: "6px", textTransform: "capitalize", fontFamily: FONT_BODY }}>
                  {booking.category}
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                  <CalendarIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }} />
                   <Typography sx={{ fontFamily: FONT_BODY, fontSize: 13, color: "rgba(255,255,255,0.92)", fontWeight: 600 }}>{booking.start_date && booking.end_date
                                                                        ? `${booking.start_date} → ${booking.end_date}`
                                                                        : booking.scheduled_date}</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                  <TimeIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }} />
                  <Typography sx={{ fontFamily: FONT_BODY, fontSize: 13, color: "rgba(255,255,255,0.92)", fontWeight: 600 }}>{booking.scheduled_time}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Body */}
          <Box sx={{ p: { xs: "16px 14px 22px", sm: "20px 22px 26px" } }}>
            <Box sx={{ display: "flex", gap: 1, mb: 2.5, flexWrap: "wrap" }}>
              <StatusChip value={booking.status} />
            </Box>

            <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11.5, fontWeight: 700, color: TEAL, letterSpacing: 0.2, mb: 1 }}>
              Patient details
            </Typography>
            <Grid container spacing={1} mb={2.5}>
              <Grid item xs={6}><InfoItem label="Name"  value={booking.patient_name}  /></Grid>
              <Grid item xs={6}><InfoItem label="Phone" value={booking.patient_phone} /></Grid>
              <Grid item xs={12}><InfoItem label="Address" value={booking.patient_address} /></Grid>
            </Grid>

            <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11.5, fontWeight: 700, color: TEAL, letterSpacing: 0.2, mb: 1 }}>
              Appointment
            </Typography>
            <Grid container spacing={1} mb={2.5}>
              <Grid item xs={6}><InfoItem label="Date"      value={booking.start_date && booking.end_date
                                                                        ? `${booking.start_date} → ${booking.end_date}`
                                                                        : booking.scheduled_date} /></Grid>
              <Grid item xs={6}><InfoItem label="Time slot" value={booking.scheduled_time} /></Grid>
            </Grid>

            {booking.notes && (
              <Box sx={{ bgcolor: "#F8FAFB", border: `1px solid ${BORDER}`, borderRadius: "10px", p: "11px 13px", mb: 2.5 }}>
                <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11, fontWeight: 600, color: INK_MUTED, mb: 0.5 }}>Notes</Typography>
                <Typography sx={{ fontFamily: FONT_BODY, fontSize: 13.5, color: "#374151", lineHeight: 1.6 }}>{booking.notes}</Typography>
              </Box>
            )}

           {booking.document_urls?.length > 0 && (
              <Box sx={{ mb: 2.5 }}>
                <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11.5, fontWeight: 700, color: TEAL, letterSpacing: 0.2, mb: 1 }}>
                  Uploaded medical records
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {booking.document_urls.map((url, i) => (
                    <Button
                      key={i}
                      variant="outlined" size="small"
                      onClick={() => setDocViewUrl(url)}
                      sx={{ borderColor: TEAL, color: TEAL, textTransform: "none", fontSize: 12.5, fontFamily: FONT_BODY, fontWeight: 600, borderRadius: "8px" }}
                    >
                      📄 Document {i + 1}
                    </Button>
                  ))}
                </Box>
              </Box>
            )}
                    {booking.invoice &&(<Button
                        variant="contained"
                        size="small"
                        startIcon={<DownloadIcon />}
                        onClick={() => {
                          handleInvoiceDownload(booking.booking_ref)
                        }}
                        sx={{ 
                          bgcolor: TEAL, 
                          '&:hover': { bgcolor: TEAL_DARK },
                          textTransform: 'none',
                          fontFamily: FONT_BODY,
                          fontWeight: 600,
                          borderRadius: '8px',
                          marginLeft:"8px"
                        }}
                      >
                        Download invoice
                      </Button>)}
                      {booking.agreement && (
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<DownloadIcon />}
                        href={booking.agreement.url}
                        target="_blank"
                        sx={{
                          borderColor: TEAL,
                          color: TEAL,
                          textTransform: 'none',
                          fontFamily: FONT_BODY,
                          fontWeight: 600,
                          borderRadius: '8px',
                          marginLeft: "8px",
                          mt: 1,
                        }}
                      >
                        View signed agreement
                      </Button>
                    )}

            {booking.created_at && (
              <Typography sx={{ fontFamily: FONT_BODY, fontSize: 11.5, color: "#9CA3AF", textAlign: "center", mt: 2, mb: canCancel ? 1.5 : 0 }}>
                Booked on {new Date(booking.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
              </Typography>
            )}

            {canCancel && (
              <Button fullWidth variant="outlined" startIcon={<CancelIcon />}
                onClick={() => onCancelRequest(booking)}
                sx={{ mt: 1, py: 1.2, borderRadius: "10px", fontWeight: 700, fontSize: 14, textTransform: "none", fontFamily: FONT_BODY, borderColor: "#F3C6C0", color: RED, "&:hover": { bgcolor: RED_SOFT, borderColor: "#EF4444" } }}>
                Cancel this booking
              </Button>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
          {/* ── Document viewer overlay — now a sibling, not a child of Modal ── */}
      <Dialog open={!!docViewUrl} onClose={() => setDocViewUrl("")} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontFamily: FONT_BODY }}>
          <Typography fontWeight={700} sx={{ fontFamily: FONT_BODY }}>Document preview</Typography>
          <IconButton onClick={() => setDocViewUrl("")} size="small"><CloseIcon fontSize="small" /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, bgcolor: "#000", minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {docViewUrl && (
            docViewUrl.toLowerCase().endsWith(".pdf") ? (
              <iframe src={docViewUrl} title="document" width="100%" height="700px" style={{ border: "none" }} />
            ) : (
              <Box component="img" src={docViewUrl} alt="document" sx={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }} />
            )
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const AllBookingsScreen = () => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [user, setUser] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedBook, setSelectedBook] = useState(null);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [medicineTotalCount, setMedicineTotalCount] = useState(0);
  const [diagnosticTotalCount, setDiagnosticTotalCount] = useState(0);
  const [physioTotalCount, setPhysioTotalCount] = useState(0);
  const [cancelling,   setCancelling]   = useState(false);
  const ROWS_PER_PAGE = 10;
  const DISPLAY_ROWS_PER_PAGE = 3 * ROWS_PER_PAGE;
  const API_FETCH_LIMIT = 1000;
  const MEDICINE_API = process.env.REACT_APP_GET_USER_MEDICINE_ORDERS;
  const DIAGNOSTIC_API = process.env.REACT_APP_BOOKED_SERVICES_API;
  const NURSING_PHY_API = `${process.env.REACT_APP_API_BASE_URL}/nursingphysiotherapy/bookings`;
  const [snack,        setSnack]        = useState({ open: false, msg: "", sev: "success" });
  const notify = (msg, sev = "success") => setSnack({ open: true, msg, sev });

  // Load Razorpay script once
  useEffect(() => {
    if (document.getElementById("razorpay-script")) return;
    const script    = document.createElement("script");
    script.id       = "razorpay-script";
    script.src      = "https://checkout.razorpay.com/v1/checkout.js";
    script.async    = true;
    document.body.appendChild(script);
  }, []);
  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        setLoading(false);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const handleOrderClick = (order) => {
    console.log(order)
    if (order.booking_type==='medicine'){
        navigate("/order-details", { state: { orderId: order.id } });
    } else if(order.booking_type==="diagnostic"){
        const booking=order.raw
        navigate(`/booking-details/${order.raw.booking_id}`, {state: {booking:booking }});
    } else{
        const booking=order.raw
        setSelectedBook(booking)
    }
  };

const renderServiceCell = (booking) => {
  if (booking.booking_type === "medicine") {
    const items = booking.raw?.items || booking.raw?.order_items || [];

    if (items.length > 0) {
      return (
        <Box>
          {items.slice(0, 2).map((item, i) => (
            <Typography key={i} sx={{ fontFamily: FONT_BODY, fontSize: 14, fontWeight: 600, color: INK }}>
              {item.medicine_name || item.name || "Medicine"} × {item.quantity || item.qty || 1}
            </Typography>
          ))}
          {items.length > 2 && (
            <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
              +{items.length - 2} more
            </Typography>
          )}
        </Box>
      );
    }
    return <Typography sx={{ fontFamily: FONT_BODY, fontSize: 13, fontWeight: 600, color: INK_MUTED }}>-</Typography>;
  }
  return (
    <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 600, color: INK }}>{booking.service_name}</Typography>
  );
};

  const handleCancel = async (bookingId) => {
    setCancelling(true);
    try {
      const res = await fetch(
        `${API}/nursingphysiotherapy/bookings/${bookingId}/cancel`,
        { method: "PATCH", headers: { "Content-Type": "application/json", ...getAuthHeader() } }
      );
      const data = await res.json();
      if (data.success) {
        setCancelTarget(null);
        setSelectedBook(null);
        notify("Booking cancelled successfully");
        await fetchBookings();
      } else {
        notify(data.error || "Cancellation failed", "error");
      }
    } catch {
      notify("Cancellation failed. Please try again.", "error");
    }
    setCancelling(false);
  };


  const fetchBookings = async () => {
    const userId = getUserId();
    if (!userId || !user) {
      setError("Please log in to view your bookings.");
      setLoading(false);
      setRefreshing(false);
      return;
    }
    const email = user.email || "";
    const phone = user.phone || "";
    const pageNumber = page + 1;
    setLoading(true);
    setError("");
    console.log(page)
    try {
      const urls = [
        MEDICINE_API && email ? `${MEDICINE_API}/${encodeURIComponent(email)}?page=1&limit=${API_FETCH_LIMIT}` : null,
        DIAGNOSTIC_API && email && phone
          ? `${DIAGNOSTIC_API}?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}&page=1&limit=${API_FETCH_LIMIT}`
          : null,
        `${NURSING_PHY_API}?user_id=${encodeURIComponent(userId)}&page=1&limit=${API_FETCH_LIMIT}`,
      ].filter(Boolean);

      const results = await Promise.allSettled(
        urls.map((url) =>
          fetch(url, {
            headers: { "Content-Type": "application/json", ...getAuthHeader() },
          })
        )
      );
      const parsed = await Promise.all(
        results.map(async (result) => {
          if (result.status !== "fulfilled") return [];
          const res = result.value;
          if (!res.ok) return [];
          try {
            return await res.json();
          } catch {
            return [];
          }
        })
      );
      console.log(parsed)
      const medicineData = parsed[0] || [];
      const diagnosticData = parsed[1] || [];
      const nursingData = parsed[2] || [];
    const medicineTotal = Number(medicineData.total || 0);
    setMedicineTotalCount(medicineTotal)
    const diagnosticTotal = Number(diagnosticData.total || 0);
    setDiagnosticTotalCount(diagnosticTotal)
    const nursingTotal = Number(nursingData.total || 0);
    setPhysioTotalCount(nursingTotal)
    console.log(nursingTotal)

      const medicineItems = Array.isArray(medicineData.orders)
        ? medicineData.orders
        : Array.isArray(medicineData)
        ? medicineData
        : [];

      const diagnosticItems = Array.isArray(diagnosticData.bookings)
        ? diagnosticData.bookings
        : Array.isArray(diagnosticData)
        ? diagnosticData
        : [];

      const nursingItems = Array.isArray(nursingData.bookings)
        ? nursingData.bookings
        : Array.isArray(nursingData)
        ? nursingData
        : [];

      const combined = [
        ...medicineItems.map((item) => normalizeBooking(item, "medicine")),
        ...diagnosticItems.map((item) => normalizeBooking(item, "diagnostic")),
        ...nursingItems.map((item) => normalizeBooking(item, "nursing & Physiotherapy")),
      ]
        .filter(Boolean)
        .sort(
          (a, b) =>
            new Date(b.date || b.raw?.created_at || 0) -
            new Date(a.date || a.raw?.created_at || 0)
        );
      setTotalCount(Math.max(combined.length, medicineTotal + diagnosticTotal + nursingTotal));
      setBookings(combined);
      console.log(combined)
    } catch (err) {
      console.error(err);
      setError("Unable to load bookings. Please try again.");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };
 useEffect(() => {
    setPage(0);
  }, [filterType]);

  useEffect(() => {
    if (user) {
      fetchBookings();
    }
  }, [user]);

  const filteredBookings = useMemo(() => {
    if (filterType === "all") return bookings;
    return bookings.filter((booking) => booking.booking_type === filterType);
  }, [bookings, filterType]);
const currentTotalCount = filteredBookings.length;
const paginatedBookings = useMemo(() => {
  const startIndex = page * DISPLAY_ROWS_PER_PAGE;
  return filteredBookings.slice(startIndex, startIndex + DISPLAY_ROWS_PER_PAGE);
}, [filteredBookings, page]);
  const handlePay = async (booking) => {
  try {
    // Step 1: Create Razorpay order
    const res  = await fetch(
      `${API}/nursingphysiotherapy/bookings/${booking.booking_ref}/create-payment`,
      { method: "POST", headers: { "Content-Type": "application/json", ...getAuthHeader() } }
    );
    const data = await res.json();
    if (!data.success) { notify(data.error || "Could not initiate payment", "error"); return; }

    // Step 2: Open Razorpay checkout
    const options = {
      key:         process.env.REACT_APP_RAZORPAY_KEY,
      amount:      data.amount,
      currency:    data.currency,
      order_id:    data.order_id,
      name:        "Ayuja Health",
      description: booking.service_name,
      prefill:     { name: booking.patient_name, contact: booking.patient_phone },
      theme:       { color: TEAL },
      handler: async (response) => {
        // Step 3: Verify on backend
        const vRes  = await fetch(
          `${API}/nursingphysiotherapy/bookings/${booking.booking_ref}/verify-payment`,
          {
            method:  "POST",
            headers: { "Content-Type": "application/json", ...getAuthHeader() },
            body: JSON.stringify({
              razorpay_order_id:   response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature:  response.razorpay_signature,
            }),
          }
        );
        const vData = await vRes.json();
        if (vData.success) {
          notify("Payment successful! ✓");
          const posOrderData={ 
          service_type:"nursing",
            order_id: booking.booking_ref,
            items: booking.service_name,
            patient_details: booking,
            subtotal: parseInt(data.amount/100) ||0 ,
            discount: 0,
            total_amount: parseInt(data.amount/100)  ||0,
            payment: { method: "Online" },
            community_name:sessionStorage.getItem('community'),
            created_at: new Date().toISOString()
          }
            try {
              const invoice_response = await axios.post(
                `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
                posOrderData,
              );
        
            const invoice = invoice_response.data.invoice_details;
            if (invoice.storage_type === "s3") {
              // Open CloudFront URL
              window.open(invoice.cloudfront_url, "_blank");
            } else if (invoice.storage_type === "local") {
              try {
              const token = sessionStorage.getItem("token");
  
              const response = await axios.get(
                `${process.env.REACT_APP_API_INVOICE}/nursing-invoice/download/${posOrderData.order_id}`,
                {
                  responseType: "blob",
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
  
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
  
              window.open(url, "_blank");
  
            } catch (error) {
              console.error("Invoice download failed:", error);
            }
            }
            } catch (error) {
              console.error("Invoice generation failed:", error);
            }
          fetchBookings();
        } else {
          notify("Payment verification failed. Contact support.", "error");
        }
      },
      modal: {
        ondismiss: () => notify("Payment cancelled", "warning"),
      },
    };

    if (!window.Razorpay) {
      notify("Payment gateway not loaded. Please refresh.", "error");
      return;
    }
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch {
    notify("Payment failed. Please try again.", "error");
  }
};
  


  const counts = (type) => {
    if (type === "all") return totalCount;
    else if (type === "medicine") return medicineTotalCount;
    else if (type === "diagnostic") return diagnosticTotalCount;
    else if (type === "nursing & Physiotherapy") return physioTotalCount;

    return 0;
};
  

  return (
    <>
      <CssBaseline />
      <Box sx={{ minHeight: "100vh", bgcolor: PAGE_BG, fontFamily: FONT_BODY }}>

        {/* ── Masthead ─────────────────────────────────────────────────── */}
        <Box
          sx={{
            bgcolor: TEAL_DARK,
            backgroundImage: `linear-gradient(120deg, rgba(8,63,68,0.97) 0%, rgba(11,110,118,0.9) 100%), url(${bg2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderBottom: `3px solid ${CORAL}`,
          }}
        >
          <Container maxWidth="xl">
            <Box
              sx={{
                py: { xs: 2.5, md: 3.5 },
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <IconButton
                onClick={() => navigate(-1)}
                sx={{
                  color: "#fff",
                  bgcolor: "rgba(255,255,255,0.12)",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
                }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontFamily: FONT_DISPLAY, color: "#fff", fontWeight: 700, fontSize: { xs: 21, md: 27 }, letterSpacing: "-0.01em" }}>
                  Your bookings
                </Typography>
                <Typography sx={{ fontFamily: FONT_BODY, color: "rgba(255,255,255,0.78)", fontSize: { xs: 13, md: 14 }, mt: 0.3 }}>
                  Medicine orders, diagnostics and home-care visits, all in one place
                </Typography>
              </Box>
              <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={() => {
                  setRefreshing(true);
                  fetchBookings();
                }}
                disabled={refreshing}
                sx={{
                  bgcolor: "rgba(255,255,255,0.14)",
                  color: "#fff",
                  textTransform: "none",
                  fontFamily: FONT_BODY,
                  fontWeight: 600,
                  borderRadius: "10px",
                  boxShadow: "none",
                  display: { xs: "none", sm: "inline-flex" },
                  "&:hover": { bgcolor: "rgba(255,255,255,0.24)", boxShadow: "none" },
                }}
              >
                {refreshing ? "Refreshing…" : "Refresh"}
              </Button>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="xl" sx={{ py: { xs: 2.5, md: 3.5 } }}>

          {/* ── Summary strip — one card, divided, instead of four separate ones ── */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: "14px",
              border: `1px solid ${BORDER}`,
              display: "flex",
              flexWrap: "wrap",
              overflow: "hidden",
              mb: 2.5,
            }}
          >
            {BOOKING_TYPES.map((type, i) => (
              <Box
                key={type.key}
                sx={{
                  flex: "1 1 180px",
                  p: "18px 22px",
                  borderRight: {
                    md: i < BOOKING_TYPES.length - 1 ? `1px solid ${BORDER}` : "none",
                  },
                  borderBottom: {
                    xs: i < BOOKING_TYPES.length - 1 ? `1px solid ${BORDER}` : "none",
                    md: "none",
                  },
                }}
              >
                <Typography sx={{ fontFamily: FONT_BODY, fontSize: 12.5, fontWeight: 600, color: INK_MUTED, mb: 0.6 }}>
                  {type.label}
                </Typography>
                <Typography sx={{ fontFamily: FONT_DISPLAY, fontWeight: 700, fontSize: 28, color: INK }}>
                  {type.key === "all" ? totalCount : counts(type.key) || 0}
                </Typography>
              </Box>
            ))}
          </Paper>

          {/* ── Filter row ───────────────────────────────────────────────── */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1.5,
              alignItems: "center",
              mb: 2.5,
            }}
          >
            <ToggleButtonGroup
              value={filterType}
              exclusive
              onChange={(event, newType) => {
                if (newType !== null) setFilterType(newType);
              }}
              size="small"
              sx={{
                bgcolor: SURFACE,
                p: 0.5,
                borderRadius: "12px",
                border: `1px solid ${BORDER}`,
                flexWrap: "wrap",
                "& .MuiToggleButtonGroup-grouped": {
                  border: 0,
                  borderRadius: "8px !important",
                  mx: 0.25,
                  my: 0.25,
                },
              }}
            >
              {BOOKING_TYPES.map((type) => (
                <ToggleButton
                  key={type.key}
                  value={type.key}
                  disableRipple
                  sx={{
                    textTransform: "none",
                    px: 2.25,
                    py: 0.8,
                    minWidth: 100,
                    fontSize: "0.85rem",
                    fontFamily: FONT_BODY,
                    fontWeight: 600,
                    color: TEAL,
                    borderRadius: "8px",
                    transition: "all 0.2s ease",
                    "&:hover": { bgcolor: TEAL_SOFT, color: TEAL_DARK },
                    "&.Mui-selected": {
                      bgcolor: TEAL,
                      color: "#fff",
                      "&:hover": { bgcolor: TEAL_DARK },
                    },
                  }}
                >
                  {type.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={() => {
                setRefreshing(true);
                fetchBookings();
              }}
              disabled={refreshing}
              sx={{
                ml: { xs: 0, sm: "auto" },
                display: { xs: "inline-flex", sm: "none" },
                textTransform: "none",
                fontFamily: FONT_BODY,
                fontWeight: 600,
                borderRadius: "10px",
                borderColor: BORDER,
                color: TEAL,
              }}
            >
              Refresh
            </Button>
          </Box>

          {loading ? (
            <Box sx={{ textAlign: "center", py: 10 }}>
              <CircularProgress sx={{ color: TEAL }} />
            </Box>
          ) : error ? (
            <Paper sx={{ p: 4, textAlign: "center", borderRadius: "14px", border: `1px solid ${BORDER}` }} elevation={0}>
              <Typography sx={{ fontFamily: FONT_DISPLAY, mb: 1, fontWeight: 700, color: INK }}>Unable to load bookings</Typography>
              <Typography sx={{ fontFamily: FONT_BODY, color: INK_MUTED, mb: 2 }}>
                {error}
              </Typography>
              <Button
                variant="contained"
                onClick={fetchBookings}
                sx={{ bgcolor: TEAL, textTransform: "none", fontFamily: FONT_BODY, fontWeight: 600, borderRadius: "10px", "&:hover": { bgcolor: TEAL_DARK } }}
              >
                Retry
              </Button>
            </Paper>
          ) : paginatedBookings.length === 0 ? (
            <Paper sx={{ p: 6, textAlign: "center", borderRadius: "14px", border: `1px solid ${BORDER}` }} elevation={0}>
              <Typography sx={{ fontFamily: FONT_DISPLAY, fontWeight: 700, fontSize: 18, color: INK, mb: 1 }}>
                No bookings found
              </Typography>
              <Typography sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
                Try another filter or refresh to load your latest bookings.
              </Typography>
            </Paper>
          ) : (
            <>
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "14px", border: `1px solid ${BORDER}`, overflow: "hidden" }}>
              <Table sx={{ minWidth: 1200 }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#F8FAFB" }}>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Type</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Booking ID</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Service</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Patient</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, minWidth: 200, borderBottom: `1px solid ${BORDER}` }}>Booked / ordered date</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Status</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Amount</TableCell>
                    <TableCell sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Payment</TableCell>
                    <TableCell align="right" sx={{ color: INK_MUTED, fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, borderBottom: `1px solid ${BORDER}` }}>Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedBookings.map((booking) => {
                    const statusChip = getStatusChipProps(booking.status);
                    const paymentChip = getPaymentStatusChipProps(booking.payment_status);
                    const bookingTypeChip = getBookingTypeChipStyles(booking.booking_type);

                    return (
                      <TableRow
                        key={`${booking.booking_type}-${booking.id}`}
                        sx={{
                          "&:hover": { bgcolor: TEAL_SOFT },
                          "&:last-child td": { borderBottom: 0 },
                          transition: "background-color 0.15s ease",
                        }}
                      >
                        <TableCell sx={{ py: 2, borderBottom: `1px solid ${BORDER}` }}>
                          <Box
                            sx={{
                              display: "inline-block",
                              textTransform: "capitalize",
                              bgcolor: bookingTypeChip.bgcolor,
                              color: bookingTypeChip.color,
                              border: `1px solid ${bookingTypeChip.border}`,
                              fontFamily: FONT_BODY,
                              fontWeight: 700,
                              fontSize: 12,
                              borderRadius: "6px",
                              px: "8px",
                              py: "3px",
                            }}
                          >
                            {booking.booking_type}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 700, color: INK, fontSize: 13.5 }}>{booking.id}</Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          {renderServiceCell(booking)}
                          {booking.item_count > 0 && booking.booking_type ==='medicine' &&(
                            <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
                                {booking.item_count} item{booking.item_count > 1 ? "s" : ""}
                            </Typography>
                            )}
                            {booking.item_count > 0 && booking.booking_type ==='nursing & Physiotherapy' && (
                            <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
                                {booking.item_count} item{booking.item_count > 1 ? "s" : ""}
                            </Typography>
                            )}
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 700, color: INK, fontSize: 13.5 }}>{booking.patient_name}</Typography>
                          <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
                            {booking.patient_phone}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 700, color: INK, fontSize: 13.5, minWidth: 200 }}> {booking.date && booking.end_date
                            ? `${formatDate(booking.date)} → ${formatDate(booking.end_date)}`
                            : formatDate(booking.date)}</Typography>
                          <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED }}>
                          {formatTime(booking.date)}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <StatusDot label={statusChip.label} color={statusChip.color} bg={statusChip.bg} border={statusChip.border} />
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 700, color: INK, fontSize: 13.5 }}>
                            ₹{Math.round(booking.amount)}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                          <StatusDot label={paymentChip.label} color={paymentChip.color} bg={paymentChip.bg} border={paymentChip.border} />
                          <Typography variant="caption" sx={{ fontFamily: FONT_BODY, color: INK_MUTED, display: "block", mt: 0.4 }}>
                            {booking.payment_method}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${BORDER}` }}>
                         <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
                            {booking.raw.status === "completed" &&
                                booking.raw.amount_due &&
                                booking.raw.payment_status !== "paid" && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => handlePay(booking.raw)}
                                    sx={{ bgcolor: GREEN, borderRadius: "8px", fontWeight: 700, fontSize: 12, fontFamily: FONT_BODY, textTransform: "none", px: 1.5,
                                        "&:hover": { bgcolor: "#166534" }, animation: "pulse 2s infinite",
                                        "@keyframes pulse": {
                                            "0%,100%": { boxShadow: "0 0 0 0 rgba(22,163,74,0.4)" },
                                            "50%":     { boxShadow: "0 0 0 6px rgba(22,163,74,0)" },
                                        },}}
                                >
                                    Pay ₹{booking.raw.amount_due}
                                </Button>
                                )}
                        
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => handleOrderClick(booking)}
                            sx={{ textTransform: "none", bgcolor: TEAL, color: "#fff", fontFamily: FONT_BODY, fontWeight: 600, borderRadius: "8px", boxShadow: "none", "&:hover": { bgcolor: TEAL_DARK, boxShadow: "none" } }}
                            >
                            View
                            </Button>
                            </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
             <TablePagination
              component="div"
              count={currentTotalCount}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={DISPLAY_ROWS_PER_PAGE}
              rowsPerPageOptions={[DISPLAY_ROWS_PER_PAGE]}
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
              sx={{ mt: 2, fontFamily: FONT_BODY, "& .MuiTablePagination-toolbar": { fontFamily: FONT_BODY } }}
            />
             </>
          )}
        </Container>
        {selectedBook && (
        <BookingDetailModal
          booking={selectedBook}
          onClose={() => setSelectedBook(null)}
          onCancelRequest={(b) => { setSelectedBook(null); setCancelTarget(b); }}
        />
      )}
       {cancelTarget && (
        <CancelDialog
          booking={cancelTarget}
          onClose={() => setCancelTarget(null)}
          onConfirm={handleCancel}
          loading={cancelling}
        />
      )}

      <Snackbar
        open={snack.open}
        autoHideDuration={3500}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          severity={snack.sev}
          variant="filled"
          sx={{ fontFamily: FONT_BODY, fontWeight: 600, borderRadius: "10px" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
      </Box>
    </>
  );
};

export default AllBookingsScreen;